

module.exports = ['$scope', 'ModalSvc', 'PlantSvc', function ($scope, ModalSvc, PlantSvc) {
    'use strict';

    // ------------------
    // Scope functions
    // ------------------
    $scope.deactivatePlant = function(plant){

        var modal = ModalSvc.confirmationDialog.open({
            message: `Are you sure you want to deactivate ${plant.name}?`,
            title: `Deactivate Plant`
        });

        modal.result.then(function(result){
            PlantSvc.delete(plant.id).then(function(){
                fetchData();
                location.reload(true);
            });
        });
    };

    $scope.reactivatePlant = function(plant){

        var modal = ModalSvc.confirmationDialog.open({
            message: `Are you sure you want to reactivate ${plant.name}?`,
            title: `Reactivate Plant`
        });
        modal.result.then(function(result){
            PlantSvc.restore(plant.id).then(function(){
                fetchData();
                location.reload(true);
            });
        });
    };

    // ------------------
    // Load Dependent Data
    // ------------------
    function fetchData() {
        PlantSvc.list({
            show_inactive: true,
            permissions: "edit_plant_configuration"
        }).then((result) => {
            $scope.plants = result.data;
        });
    }

    // ------------------
    // Initialization
    // ------------------
    fetchData();

}];

